<template lang="pug">
    filter-mobile
        form.c-form.inverse

            // Sort by Full Name
            v-select(
                name="fullName"
                append-icon="expand_more"
                outline
                v-model="model.sort.name"
                @change="e => sortHandler('fullName', e)"
                :items="$t('selection.sort')"
                :label="$t('managers.mobile.sort.fullName')"
            )

            // Sort by Email
            v-select(
                name="email"
                append-icon="expand_more"
                outline
                v-model="model.sort.email"
                @change="e => sortHandler('email', e)"
                :items="$t('selection.sort')"
                :label="$t('managers.mobile.sort.email')"
            )

            // Filter by Status
            v-select(
                name="status"
                append-icon="expand_more"
                outline
                @change="e => filterHandler({ name: 'isActive', value: e})"
                :items="$t('managers.mobile.filter.status.filter')"
                :label="$t('managers.mobile.filter.status.name')"
            )

            // Filter by Role
            v-select(
                name="status"
                append-icon="expand_more"
                outline
                @change="e => filterHandler({ name: 'role', value: e})"
                :items="$t('managers.mobile.filter.role.filter')"
                :label="$t('managers.mobile.filter.role.name')"
            )
</template>

<script>
    import VueTypes from 'vue-types';
    import FilterMobile from '~components/FilterMobile';

    export default {
        components: {
            FilterMobile
        },
        data() {
            return {
                model: {
                    sort: {
                        name: null,
                        email: null
                    }
                }
            };
        },
        watch: {
            ['model.sort.name'](val) {
                if (val !== null && this.model.sort.email !== null) {
                    this.model.sort.email = null;
                }
            },
            ['model.sort.email'](val) {
                if (val !== null && this.model.sort.name !== null) {
                    this.model.sort.name = null;
                }
            }
        },
        props: {
            sortHandler: VueTypes.func.def(() => {}),
            filterHandler: VueTypes.func.def(() => {})
        }
    };
</script>

<style scoped></style>
